import script from "./var-list.vue?vue&type=script&lang=ts&setup=true"
export * from "./var-list.vue?vue&type=script&lang=ts&setup=true"

import "./var-list.vue?vue&type=style&index=0&id=c91bd6d6&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\WebStorm\\operation-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c91bd6d6"]])

export default __exports__